import * as React from "react";
import { Row, Col, ListGroup, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { CreateAccountUIActionTypes, RecoveryMethod } from "src/common";

type AllProps = {
  handleAction: ActionHandlerFunction;
}

function ChoosePanelComponent(props: AllProps) {
    const { handleAction } = props;
    
    return <Row className="justify-content-center">
    <Col md={10} className="my-4">
      <ListGroup className="public-card" horizontal>
        <ListGroup.Item className="image">
          <div className="copy-account-image"></div>
        </ListGroup.Item>
        <ListGroup.Item className="content">
          <p className="title">Recover using recovery file</p>
          <p>
            Use your PDF file to reset your password.
          </p>
          <Button className="btn btn-primary" onClick={() => { handleAction({ actionType: CreateAccountUIActionTypes.ChooseRecoveryMethod, params: RecoveryMethod.File });}}>Copy from Device</Button>
        </ListGroup.Item>
      </ListGroup>
      <ListGroup className="public-card" horizontal>
        <ListGroup.Item className="image">
          <div className="recovery-group-image"></div>
        </ListGroup.Item>
        <ListGroup.Item className="content">
          <p className="title">Recover through recovery group</p>
          <p>
            Your password will be reset with the authorization of
            your recovery group members.
          </p>
          <Button className="btn btn-primary" onClick={() => {handleAction({ actionType: CreateAccountUIActionTypes.ChooseRecoveryMethod, params: RecoveryMethod.Group });}}>Recover Key</Button>
        </ListGroup.Item>
      </ListGroup>
    </Col>
  </Row>;
}

export default React.memo(ChoosePanelComponent);
